import http from './public'
// 首页最新讯息
export const zhiboIndex = (params) => {
  if (typeof (params.url) === 'undefined') {
    return http.fetchGet('/v2/live/livetv', null)
  } else {
    return http.fetchGet('/v2/live/livetv/' + params.url, null)
  }
}
// 时间变化是获取直播列表
export const getzhibolist = (params) => {
  return http.fetchGet('/v2/live/livetv?startDate=' + params)
}
export const zhiboIndexSG = (params) => {
  return http.fetchGet('/v2/live/livetv/sg', params)
}
export const specialsubtables = (params) => {
  return http.fetchGet('/v2/specialsubtables?per_page = 6', params)
}
export const indexFirstlist = (params) => {
  return http.fetchGet('/v2/newcategory?scope=amtb&filter=topspeechhome&limit=6', params)
}
export const baoentree = (params) => {
  return http.fetchGet('/v2/newcategory?scope=amtb&hotspeechlimit=10', params)
}
export const baoentreeQuery = (params) => {
  let url = '/v2/newcategory'
  params.paramer.forEach(function (item, index, arr) {
    url = url + '/' + item
  })
  url = url + '?scope=amtb&sort_type=' + params.type + '&sort_column=' + params.column + '&page=' + params.page + '&per_page=' + params.pagenum
  return http.fetchGet(url)
}
export const baoentreeQueryAll = (params) => {
  let url = '/v2/newcategorysearch'
  params.paramer.forEach(function (item, index, arr) {
    url = url + '/' + item
  })
  url = url + '?scope=amtb&sort_type=' + params.type + '&sort_column=' + params.column + '&page=' + params.page + '&per_page=' + params.pagenum
  return http.fetchGet(url)
}
export const baoenQueryList = (params) => {
  let url = '/v2/baen/'
  params.forEach(function (item, index, arr) {
    url = url + '/' + item
  })
  return http.fetchGet(url)
}
export const report = (params) => {
  return http.fetchPost('/report', params)
}
export const dianbo = (params) => {
  let url = '/v2/medias'
  params.forEach(function (item, index, arr) {
    url = url + '/' + item
  })
  return http.fetchGet(url, null)
}
export const dianboOrder = (params, sortType) => {
  let url = '/v2/medias'
  params.forEach(function (item, index, arr) {
    url = url + '/' + item
  })
  url = url + '?sort_type=' + sortType
  return http.fetchGet(url, null)
}
export const playlist = (params) => {
  let url = '/v2/playlist?src=' + params
  return http.fetchGet(url, null)
}
export const search = (params) => {
  let url = '/search'
  return http.fetchPost(url, params)
}



// WEBPACK FOOTER //
// ./src/api/zhibo.js